<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="电控参数配置" subheading="" />
      <div>
        <a @click="save">保存</a>
        <a @click="cel">取消</a>
      </div>
    </div>
    <h3>

    </h3>
    <ul>
      <li>
        <span class="faceConfigTip"><b>*</b>名称</span><el-input v-model="name" class="faceConfigInput" :maxlength="maxlength" />
        <span class="red" v-if="name_tip"><span v-html="name_text"></span></span>
      </li>
      <li>
        <span class="faceConfigTip"><b>*</b>电费(元/度)</span><el-input v-model="unitPrice" class="faceConfigInput" :maxlength="maxlength" />
        <span class="red" v-if="unitPrice_tip"><span v-html="unitPrice_text"></span></span>
      </li>
      <li>
        <span class="faceConfigTip"><b></b>提示语</span><el-input v-model="warmMessage" class="faceConfigInput" :maxlength="maxlength" />
      </li>
    </ul>
  </div>
</template>

<script>
  import {commonConfig} from '../common'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import {pattern} from '../../../utils/regular'
  import {httpUrl} from '../../api/httpUrl'
  import TextTitle from '../../../components/Text/TextTitle'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'

  export default {
    components: {
      Breadcrumb,
      TextTitle,
    },
    name: 'modify-electronic-config',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用电',
            name: 'electronic-config'
          }, {
            value: '基本配置',
          }],
        },
        maxlength: 64,
        name: '',
        unitPrice: '',
        warmMessage: '',
        name_text: '请输入名称',
        unitPrice_text: '请输入电费金额',
        name_tip: false,
        unitPrice_tip: false
      }
    },
    created () {
      this.getFaceConfigData()
    },
    methods: {
      cel () {
        this.$router.push({
          name: 'electronic-config'
        })
      },
      save () {
        if (this.name_tip || this.unitPrice_tip) {
          return false
        }
        if (!this.name) {
          this.name_tip = true
          this.name_text = '请输入名称'
          return false
        }
        if (!this.unitPrice) {
          this.unitPrice_tip = true
          this.unitPrice_text = '请输入电费金额'
          return false
        }
        this.updateFaceConfig()
      },
      getFaceConfigData () {
        this.$axios.post(`${httpUrl.host}/gy-electric/basicConfig/getConfig`, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              this.name = data.configName
              this.unitPrice = data.unitPrice
              this.warmMessage = data.warmMessage
            }
          })
          .catch(errorHandler('获取配置数据失败'))
      },
      updateFaceConfig () {
        this.$axios.post(`${httpUrl.host}/gy-electric/basicConfig/saveOrUpdate`, {
          configName: this.name,
          unitPrice: this.unitPrice,
          warmMessage: this.warmMessage
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.$router.push({
                name: 'electronic-config'
              })
            }
          })
          .catch(errorHandler('配置修改失败'))
      }
    },
    watch: {
      name (v) {
        if (v) {
          this.name_tip = false
          let nameReg = pattern.accountName
          let idTest = nameReg.test(this.name)
          if (!idTest) {
            this.name_tip = true
            this.name_text = '名称只能由中文数字字母组成'
          } else {
            this.name_tip = false
          }
        }
      },
      unitPrice (v) {
        if (v) {
          this.unitPrice_tip = false
          let faceConfigReg = pattern.subsidy
          let keyTest = faceConfigReg.test(this.unitPrice)
          if (!keyTest) {
            this.unitPrice_tip = true
            this.unitPrice_text = '电费金额由数字组成且保留小数点后两位'
          } else {
            this.unitPrice_tip = false
          }
        }
      }
    }
  }
</script>

<style scoped>
  .main_right {
    text-align: left;
  }
  .flexBox {
    display: flex;
    justify-content: space-between;
  }

  .flexBox a{
    line-height: 58px;
    margin-right: 40px;
    cursor: pointer;
  }
  .flexBox a:hover{
    color: #00a0e6;
  }
  .main_right ul {
    width: 80%;
    margin: 10px auto 0;
    line-height: 40px;
  }

  .main_right ul li {
    width: 100%;
    padding: 4px 0;
    margin-bottom: 10px;
  }

  .main_right ul b {
    color: red;
  }
  .red {
    color: red;
  }
</style>

<style lang="less">
  .main_right {
    .faceConfigTip {
      display: inline-block;
      min-width: 80px;
      text-align: right;
    }
    .faceConfigInput {
      display: inline-block;
      width: 313px;
      height: 28px;
      margin-left: 10px;
      .el-input__inner {
        height: 28px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectronicControl/electronic-config/modify-electronic-config.vue